import { formatDateTime, parseDateTime } from 'utils/dates/date.utils';
import { getMarineWidgetLayout } from '../../../utils/marineForecastWidget.utils';

export const getBuoyConditionsWidgetLayout = getMarineWidgetLayout;

export const getBuoyConditionsWidgetLocationOptions = (locations) =>
  locations.map(({ locationKey, locationName }) => ({
    label: locationName,
    value: locationKey,
  }));

export const getBuoyConditionsWidgetObservationDateLabel = (entry) =>
  formatDateTime(entry?.utcTime, 'short', 'Observation', true);

export const getBuoyConditionsWidgetObservationTimeLabel = (entry) => {
  const observationTime = parseDateTime(entry?.utcTime);

  if (!observationTime) return 'Time unavailable';

  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(observationTime);
};

export const getBuoyConditionsWidgetTileAriaLabel = (entry) =>
  `Select buoy observation from ${formatDateTime(entry?.utcTime, 'short', 'an unavailable time')}`;
